<!-- /web/common-index -->

<template>
  <div>
    <div class="page">
      <div class="content-box">
        <city-select :cate-id="cateId"></city-select>
        <div class="body-box">
          <!-- 参考 BudoNoticeBar -->
          <van-notice-bar v-if="notice" left-icon="volume-o" mode="closeable" scrollable>
            {{ notice }}
          </van-notice-bar>

          <!-- 关联板块ID配置广告 -->
          <ads-images :code="'common_index_images_cate_' + cateId" />

          <div class="box3 flex-row row-between col-center">
            <div class="flex-row col-center">
              <div class="iconfont icon-gongneng"></div>
              <div>正品保证</div>
            </div>
            <div class="flex-row col-center">
              <div class="iconfont icon-wuliupeisong-"></div>
              <div>全国配送</div>
            </div>
            <div class="flex-row col-center">
              <div class="iconfont icon-kuaidi"></div>
              <div>下单立发</div>
            </div>
            <div class="flex-row col-center">
              <div class="iconfont icon-shouhou"></div>
              <div class="budo-28">售后无忧</div>
            </div>
          </div>

          <div style="display: flex;flex-direction:row;overflow-x: scroll;background-color: #FFFFFF;padding: 16px;border-radius: 8px;margin: 0 15px">
            <div v-for="cate of cateList" :key="cate.cateId"
              style="display: block; margin: 0 8px;background-color: #FFFFFF;text-align: center"
              @click="toDetail(cate.cateId, cate.topicId)">
              <van-image :src="cate.headImage" height="64px" width="64px" />
              <span style="font-size: 12px;display: block">{{ cate.name }}</span>
            </div>
          </div>

          <div class="box5 mt10">
            <div class="module-common-index-40" style="font-size: 15px;color: #252525;font-weight: bold;padding-top: 10px;padding-left: 10px ; ">
              精品推荐
            </div>
            <GoodsListBlock :cate-id="cateId" :tags="recommendTag" />
          </div>

          <div class="box6 mt10 module-common-index-48">
            <van-tabs v-model="tabActive" background="rgba(0,0,0,0)">
              <van-tab title="精选">
                <MallSortTable :cate-id="cateId" />
              </van-tab>
              <van-tab v-for="cate in cateList" :key="cate.cateId" :title="cate.name">
                <MallSortTable :cate-id="cate.cateId" />
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </div>
    </div>

    <PageFooter :active="0"></PageFooter>
  </div>
</template>

<script>
import GoodsListBlock from "@/components/common/GoodsListBlock";
import AdsImages from "@/components/common/ads-images";
import CitySelect from "@/components/common/city-select";
import MallSortTable from "@/components/common/MallSortTable";
import { GOODS_CATE_INFO, GOODS_TAGS, MallModules } from "@/api/constant";
import { api_get_goods_cate_list } from "@/api/goods-api";
import TabBarBook from "@/components/common/tabbar-books";
import PageFooter from "@/components/common/page-footer";
import { getSysConfigValue } from "@/api/sys-api";
import BudoNoticeBar from "@/components/BudoNoticeBar.vue";

export default {
  name: "module-common-index",

  components: { PageFooter, TabBarBook, GoodsListBlock, AdsImages, CitySelect, MallSortTable, BudoNoticeBar },

  data() {
    return {
      tabActive: 0,
      cateList: [],
      goodsList: [],
      cateInfo: GOODS_CATE_INFO.drama, // 为何默认这个 搞不懂
      cateId: GOODS_CATE_INFO.drama.id,
      recommendTag: GOODS_TAGS.recommend,
      notice: ''
    }
  },

  created() {
    window.onscroll = this.doScroll;
    this.cateId = Number(this.$route.query.cateId || 0);

    budo_log.info("#97 this.cateId", this.cateId)

    const module = MallModules.find((mall) => mall.topCateId === this.cateId);
    if (module) {
      this.$store.commit("SET_MALL_MODULE", module);
    }

    for (const cate in GOODS_CATE_INFO) {
      if (GOODS_CATE_INFO[cate].id === this.cateId) {
        this.cateInfo = GOODS_CATE_INFO[cate];
        budo_log.debug("#116 this.cateInfo", this.cateInfo)
      }
    }

    if (Number(this.cateId) === GOODS_CATE_INFO.movie_other.id) {
      getSysConfigValue('Movie_Other_Index_Notice').then(res => {
        this.notice = res.data;
      })
    }

    api_get_goods_cate_list(this.cateId).then(res => {
      this.cateList = res.data;
    });
  },

  methods: {
    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.debug("#130 window.pageYOffset=", window.pageYOffset)
      }, 300);
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },

    toDetail(cateId, topicId) {
      if (topicId > 0) {
        this.$router.replace({ path: 'topic-detail', query: { topicId: topicId, buyFlag: '1' } })
        return
      }

      this.$router.replace({ path: 'cate-index', query: { cateId: cateId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #EDF0F5;
  padding-bottom: 120px;
  min-height: 100vh;

  .content-box {
    .box1 {
      padding: 0 11px;
      background-color: white;

      ::v-deep {
        .van-dropdown-menu__bar {
          box-shadow: unset;
        }
      }
    }
    .body-box {
      padding: 10px 0;

      .box2 {
        padding: 0 15px;

        .my-swipe {
          border-radius: 5px;

          .van-swipe-item {
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
          }
        }
      }

      .box3 {
        padding: 0 15px;
        color: #9A9A9A;
        font-size: 12px;
        margin: 14px 0;
      }

      .box4 {
        // height: 100px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 10px;
        font-size: 12px;
        color: #333333;
      }

      .box5 {
        height: 205px;
        background: #FFFFFF;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box6 {
        padding: 0;

        .goods-box {
          margin-top: 10px;

          .goods-item {
            width: 133px;
            height: 261px;
            background: #FFFFFF;
            border-radius: 4px;
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
